// removed by extract-text-webpack-plugin
module.exports = {"red":"_2PF218WrDZ5jysMK3s49Uf","dark-red":"#a30000","white":"#ffffff","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","black":"#000000","normal":".3s","inputField":"_2h1_uqOsFSNaYDijKQ-TrQ","select":"_3UPNVx5xGaEaQ9vyAjIjdW","darkBg":"_11Dij5TPu0Q-E5Bdr5oj7P","selectedMeter":"_2wVP2gyYQwnC5cTeo2MZ4M","s":"_1zgQyPvN8CIzHLHZr5j7gp","m":"_1q4KIpQ6LL5w-jU0y7F-zq","l":"N5_hB1nm1_UrzKunrcPEr","xl":"vJdx_ycRyP-UkzzCz4buf","isSelected":"_1kOVyw10QOHyHLFOUxH7XT","withLabel":"_3v3YQu3u4__vFga2xSyoBI","disabled":"_1UBHa21Q4xiEOmMilMMatG","simplified":"_3YP79ifWQZaDlALyKjoOrz"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Inputs/Dropdown.css
// module id = 910
// module chunks = 0